/**
 * @param {{ leg_management_version?: number } | null | undefined} entity
 * @returns {boolean}
 */
export const isLegManagementEnabled = (entity) => (entity === null || entity === void 0 ? void 0 : entity.leg_management_version) === 2;
